var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoxAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 15.0013C19.1667 15.6263 18.9917 16.218 18.6833 16.718C18.5083 17.018 18.2833 17.2846 18.025 17.5013C17.4417 18.0263 16.675 18.3346 15.8333 18.3346C14.8167 18.3346 13.9083 17.8763 13.3083 17.1597C13.2917 17.1347 13.2667 17.118 13.25 17.093C13.15 16.9763 13.0583 16.8513 12.9833 16.718C12.675 16.218 12.5 15.6263 12.5 15.0013C12.5 13.9513 12.9833 13.0096 13.75 12.4013C14.325 11.943 15.05 11.668 15.8333 11.668C16.6667 11.668 17.4167 11.9679 18 12.4763C18.1 12.5513 18.1917 12.643 18.275 12.7347C18.825 13.3347 19.1667 14.1263 19.1667 15.0013Z",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0751 14.9805H14.5918",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 13.7656V16.2573",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6416 6.20312L9.99994 10.4614L17.3083 6.2281",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.0115V10.4531",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99121 12.3597V7.64297C1.99121 6.49297 2.81621 5.09299 3.82454 4.53465L8.27454 2.06797C9.22454 1.53464 10.7746 1.53464 11.7245 2.06797L16.1745 4.53465C17.1829 5.09299 18.0079 6.49297 18.0079 7.64297V12.3597C18.0079 12.4013 18.0079 12.4346 17.9995 12.4763C17.4162 11.968 16.6662 11.668 15.8329 11.668C15.0495 11.668 14.3245 11.943 13.7495 12.4013C12.9829 13.0097 12.4995 13.9513 12.4995 15.0013C12.4995 15.6263 12.6745 16.218 12.9829 16.718C13.0579 16.8513 13.1495 16.9763 13.2495 17.093L11.7245 17.9347C10.7746 18.468 9.22454 18.468 8.27454 17.9347L3.82454 15.468",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxAdd);
export default __webpack_public_path__ + "static/media/box-add.8a9dbad64ccea7b9288ae6d2bfa8ef93.svg";
export { ForwardRef as ReactComponent };